module.exports = __webpack_public_path__ + "static/escrow-account_scheme-en-b7eec51a524d1e425e5bcc3bd966d0ea.svg";